import * as React from "react";
import { connect } from "react-redux";

import { DispatchType } from "shared/utilities";
import * as Actions from "../../actions/ProcessListActions";
import { ConfirmDeleteDialogState } from "../../model/ConfirmDeleteDialogState";
import { State } from "../../model/State";
import DeleteModal from "shared/components/DeleteModal";

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = (props: ConfirmDeleteDialogProps) => {
    return (
        <DeleteModal
            show={props.showConfirmDelete}
            elementsToDelete={props.processesToDelete}
            warnings={props.warnings}
            blockDelete={props.blockDelete}
            modalWarningLabel={props.modalWarningLabel}
            onDelete={props.onDelete}
            onClose={props.onClose}
        />
    );
};

interface ConfirmDeleteDialogOwnProps {

}

interface ConfirmDeleteDialogDispatchProps {
    onDelete: (ids: number[]) => void;
    onClose: () => void;
}

export type ConfirmDeleteDialogProps = ConfirmDeleteDialogOwnProps & ConfirmDeleteDialogState & ConfirmDeleteDialogDispatchProps;
const mapStateToProps = (state: State, ownProps: ConfirmDeleteDialogOwnProps): ConfirmDeleteDialogState => {
    return {
        showConfirmDelete: state.confirmDeleteDialogState.showConfirmDelete,
        processesToDelete: state.confirmDeleteDialogState.processesToDelete,
        warnings: state.confirmDeleteDialogState.warnings,
        blockDelete: state.confirmDeleteDialogState.blockDelete,
        modalWarningLabel: state.confirmDeleteDialogState.modalWarningLabel
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>): ConfirmDeleteDialogDispatchProps => {
    return {
        onDelete: (ids: number[]) => dispatch(Actions.deleteProcesses(ids)),
        onClose: () => dispatch(Actions.closeConfirmDeletDialog())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteDialog);
